import { Routes, Route, useNavigate, Outlet } from "react-router-dom";

//Dynamic pages
import Navbar from "./globalComponents/Navbar/Navbar";
import Portal from "./globalComponents/Portal";
import { Footer } from "./globalComponents/Footer";
import { SessionCatalog } from "./pages/sessionCatalog";
import { AgendaPage } from "./pages/agenda/agenda";
import { Login } from "./pages/sessionCatalogLogin/SessionCatalogLogin";
import { TestPage } from "./pages/testPage";
import { SurveyPage } from "./pages/surveys";
import { AttendeePortal } from "./pages/attendeePortal";

//global css
import "./style.css";

const App = (props) => {
  let navigate = useNavigate();

  let lastUrl = window.location.pathname;
  // console.log(window.initialState)

  new MutationObserver(() => {
    const url = window.location.pathname;
    
    if (url !== lastUrl) {
      navigate(url, { replace: true });
    }
  }).observe(document, { subtree: true, childList: true });

  //routes need to start with the workflow
  return (
    <Routes>
      <Route
        path="*"
        element={
          <>
            <Portal
              container={document.querySelector(".rf-org-header-container")}
            >
              <Navbar env={props.env} />
            </Portal>

            <Portal
              container={document.querySelector(".rf-org-footer-container")}
            >
              <Footer env={props.env} />
            </Portal>
            <Outlet />
          </>
        }
      >
        <Route path="attendee-portal-staging">
          <Route path="page/portal" element={<AttendeePortal env={props.env} />} />
          <Route path="page/surveys" element={<SurveyPage env={props.env} />} />
          <Route path="page/sessioncatalog" element={<SessionCatalog env={props.env} />} />
          <Route path="page/agenda" element={<AgendaPage env={props.env}/>} />
          <Route path="login" element={<Login env={props.env} />} />
        </Route>
        <Route path="attendee-portal">
          <Route path="page/portal" element={<AttendeePortal env={props.env} />} />
          <Route path="page/surveys" element={<SurveyPage env={props.env} />} />
          <Route path="page/sessioncatalog" element={<SessionCatalog env={props.env} />} />
          <Route path="page/agenda" element={<AgendaPage env={props.env}/>} />
          <Route path="login" element={<Login env={props.env} />} />
        </Route>

        <Route path="sessioncatalog">
            <Route path="login" element={<Login env={props.env} />} />
            <Route path="page/sessioncatalog" element={<SessionCatalog env={props.env} />} />
        </Route>
        <Route path="reg/page/surveys" element={<SurveyPage env={props.env}/>} />
        <Route path="test" element={<TestPage env={props.env} />}></Route>
      </Route>
    </Routes>
  );
};
export default App;
